<script>
import DateTimePickerBase from '@satellite/modules/appointments/components/DateTimePickerBase';

/**
 * Date Time picker that uses availability from API based on existing appointment or create appointment form data
 * @displayName Date Time Picker
 */
export default {
  name: 'DateTimePicker',
  extends: DateTimePickerBase,
  computed: {
    docks() {
      const docks = this.selectedWarehouse?.docks || {};
      return docks.filter(d => d.loadTypeIds.includes(this.selectedLoadType.id));
    }
  },
  watch: {
    selectedDock(newVal) {
      if (newVal?.id && newVal.id !== this.appointment?.dockId) {
        this.selectedTime = null;
        this.$emit('input', this.selectedTime);
      }
    }
  },
  methods: {
    mixpanelTrack() {
      if (this.$warehouseId && this.$warehouseOrgId) {
        this.mixpanel.track(this.mixpanel.events.ACTION.DATE_TIME_SELECTED, {
          'Warehouse ID': this.$warehouseId,
          'Org ID': this.$warehouseOrgId
        });
      }
    },
    initializeSetOpenDatesVars() {
      // It is important to set it to null,
      // so we don't disable dates in case of failure
      this.openDates = null;
      const docks = this.selectedWarehouse?.docks;
      return { docks };
    }
  }
};
</script>
<style lang="scss">
.date-nav {
  border: none !important;
  margin-top: 15px;
}
</style>
